import styled from 'styled-components'
import colors from 'globals/colors'
import { DatePicker } from 'antd'

const topLayerBreakpoint = 1200

export const TopLayer = styled.div`
  margin-bottom: 35px;
`

export const MailWrapper = styled.div`
  height: calc(100% - 175px);
`

export const SearchProvisioning = styled.div`
  display: inline-block;
  width: 40%;
  height: 140px;
  background: white;
  border-radius: 4px;
  padding: 15px;

  p {
    margin: 0;
  }

  @media (max-width: ${topLayerBreakpoint}px) {
    width: 100%;
  }
`

export const ProvisioningInformations = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  float: right;
  width: 55%;
  height: 140px;
  background: ${colors.gold};
  border-radius: 4px;

  svg {
    min-width: 162px;
    margin: 16px 25px;
  }

  span {
    margin-right: 40px;

    color: white;
  }

  @media (max-width: ${topLayerBreakpoint}px) {
    display: none;
  }
`

export const PrettyDatePicker = styled(DatePicker)`
  &.ant-picker {
    min-width: 250px;
    padding: 0;
    border-radius: 2px;
  }

  .ant-picker-input input {
    padding: 10px;
  }

  .ant-picker-suffix {
    border-radius: 0 2px 2px 0;
    padding: 14px;
    background-color: ${colors.waterBlue};

    svg {
      color: white;
    }
  }

  .ant-picker-clear {
    margin-right: 50px;
  }
`
